/**
 * PDFPreview — F-003.4 Phase 4 (IMPL-P4-004).
 *
 * Anteprima PDF in-browser tramite `<object data type="application/pdf">`.
 * Fallback (browser senza plugin / mobile): testo + link `<a download>` per
 * scaricare il file. Nessuna libreria esterna (PDF.js è deferred a V2).
 */
export interface PDFPreviewProps {
  previewUrl: string;
  fileName?: string;
}

export function PDFPreview({ previewUrl, fileName = 'contratto.pdf' }: PDFPreviewProps) {
  return (
    <div className="border rounded-lg overflow-hidden">
      <object
        data={previewUrl}
        type="application/pdf"
        width="100%"
        height="500"
        aria-label="Anteprima contratto"
      >
        <div className="p-4 text-center text-muted-foreground space-y-2">
          <p className="text-sm">Anteprima non disponibile nel browser.</p>
          <a
            href={previewUrl}
            download={fileName}
            className="text-sm text-primary underline hover:no-underline"
            aria-label={`Scarica ${fileName}`}
          >
            Scarica PDF
          </a>
        </div>
      </object>
    </div>
  );
}
